module.exports = __webpack_public_path__ + "media/site_templates/www.floor-sanding.net.au/images/our_services_2-8fd1560a4dd6aabdf8905be90a34bc4a.jpg";